// LES ROLES, DEFINIS UNE SEULE FOIS.
//
// Ils l'etaient DEUX fois -- dans `pages/Utilisateurs.js` (les comptes vus par
// le client) et dans `components/ComptesClient.js` (les memes comptes vus par
// l'editeur, depuis l'espace plateforme). Le 24/09/2026 le role `mecanicien` a
// ete ajoute dans la premiere et pas dans la seconde : l'editeur, qui est le
// chemin NORMAL d'ouverture d'un compte, ne pouvait pas l'attribuer. Signale
// par Yanis le jour meme, sur la production.
//
// C'est le meme defaut que le projet documente ailleurs (`_get_*_de_org`,
// `stock.deplacer`, `recurrences.CATALOGUE`) : une liste recopiee finit par
// diverger, et c'est la copie oubliee qui fait le degat.
//
// ORDRE : du MOINS au PLUS privilegie. Le premier element d'une liste se lit
// comme le choix par defaut ; mettre « Administrateur » en tete inviterait a
// le prendre.
//
// `superadmin` N'EST PAS ICI, ET NE DOIT JAMAIS Y ETRE. Le role editeur
// n'appartient a aucun schema d'ecriture cote serveur : il est pose en dur
// depuis `auth.ROLE_SUPERADMIN`. Une entree ici ne le rendrait pas
// attribuable -- le serveur refuserait -- mais proposerait un choix qui
// echoue, ce qui est pire qu'un choix absent.
export const ROLES = [
  {
    valeur: "mecanicien",
    label: "Mécanicien",
    aide: "Inspections et stock. Ne voit ni les coûts ni le financement.",
  },
  {
    valeur: "travailleur",
    label: "Travailleur",
    aide: "Saisit les opérations et les inspections, et ajoute des véhicules.",
  },
  {
    valeur: "admin",
    label: "Administrateur",
    aide: "Gère en plus le parc, les comptes et les réglages.",
  },
];

/** Le libelle d'un role, ou sa valeur brute si elle est inconnue.
 *
 * Le repli compte : une base peut porter un role qu'un ecran plus ancien ne
 * connait pas, et afficher une case vide laisserait croire que le compte n'a
 * pas de role. */
export function labelRole(valeur) {
  const r = ROLES.find((x) => x.valeur === valeur);
  return r ? r.label : valeur;
}

/** Peut-il AJOUTER des véhicules (à la main ou par import) ?
 *
 * ⚠️ Le double de `auth.ROLES_AJOUT_VEHICULE` côté serveur (05/10/2026) : si
 * l'un change, changer l'autre. Un bouton montré à qui le serveur refuse mène
 * à un 403 ; un bouton caché à qui le serveur accepte, c'est le défaut qui a
 * fait ouvrir ce droit — un compte travailleur seul devant un parc vide.
 * Le super-admin n'y est pas : en consultation, il est en lecture seule. */
export const ROLES_AJOUT_VEHICULE = ["admin", "travailleur"];

export function peutAjouterVehicule(user) {
  return Boolean(user) && ROLES_AJOUT_VEHICULE.includes(user.role);
}

/** L'explication d'un role, ou une chaine vide. */
export function aideRole(valeur) {
  const r = ROLES.find((x) => x.valeur === valeur);
  return r ? r.aide : "";
}
